module.exports = __webpack_public_path__ + "media/icons/offer-details-ciezarowe-63d6aca7.png";